import { combineReducers } from 'redux';
import App from './app/reducer';

export default combineReducers({
  App,
});
